{{if data && data.length  > 0}}
<table class="u-table-list">
	<tr>
		<th>获奖时间</th><th>礼品名称</th>	</tr>
	{{each data v idx}}
		<tr>
			<td>{{v.time}} </td><td>{{v.giftName}}</td>			
			
		</tr>
	{{/each}}

</table>　
{{else}}
	还没有您的获奖记录
{{/if}}




// WEBPACK FOOTER //
// /usr/local/src/vipp-cli/web_modules/component/hdplatform/giftEx/giftExchangeList.tpl